import { atomFamily } from "recoil";
import { ocPersistAtom } from "./persist-atom";

export const ocTimeCounterState = atomFamily({
  key: "ocTimeCounterState",
  default: {
    availableList: [],
    page: 1,
    pageSize: 25,
    selectedList: [],
    total: 0,
    totalPages: 1,
  },
  effects_UNSTABLE: [ocPersistAtom],
});
